import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { OperationsService } from 'src/app/core/services/operations.service';
import { PropertiesSettings as ps } from "../../../core/configuration/properties-settings";
import { HelpersService } from "../../../core/services/helpers.service";
import { SpesaLegale } from "../../models/tipologiche/spesa-legale";
import { TipoTipologica } from "../../models/tipologiche/tipo-tipologica";
import { FormValidationService } from "../../services/form-validation.service";
import { BaseForm } from "../base-Form";

export abstract class SpeseLegaliForm extends BaseForm {
  request: SpesaLegale;
  spesaLegaleForm: FormGroup;
  optionTipoGiudizio: TipoTipologica[] = [];
  optionGrado: TipoTipologica[] = [];
  idPetitumQuantificabile = ps.ID_TIPO_PETITUM_QUANTIFICABILE;
  constructor(protected operationService: OperationsService,
              private campiForm: FormBuilder,
              private helpers: HelpersService,
              private formValidationService: FormValidationService) {
    super();
  }

  populateSelect() {
    if (this.optionTipoGiudizio.length === 0) {
      this.helpers.getTipiGiudizi().subscribe(response => this.optionTipoGiudizio = response);
    }

    if (this.optionGrado.length === 0) {
      this.helpers.getGradi().subscribe(response => this.optionGrado = response);
    }
  }

  createForm(tipoPetitium) {
    this.request = this.getAdapter();

    this.spesaLegaleForm = this.campiForm.group({
      dataInizioCalcoloInteressi: [this.request.dataInizioCalcoloInteressi, (tipoPetitium === this.idPetitumQuantificabile) ? Validators.required : null],
      tipoGiudizio: [this.request.tipoGiudizio, Validators.required],
      grado: [this.request.grado, Validators.required],
      importo: [this.request.importo, Validators.required]
    });
  }

  update() {
    this.getRequest(this.request);
  }

  abstract getAdapter(): SpesaLegale;
  abstract getRequest(request: SpesaLegale);
}

